import React, { useEffect, useState } from "react";
import * as styled from "./styles";

const COOKIE_CONSENT_KEY = "cookieConsent";
const CONSENT_EXPIRY_DAYS = 180;

const CookiePopup = () => {

    const [showCustomiseModal, setShowCustomiseModal] = useState(false)
    const [showCookieConfig, setShowCookieConfig] = useState(false)

    const acceptCookie = (accepted) => {
        localStorage.setItem(
            COOKIE_CONSENT_KEY,
            JSON.stringify({ accepted: accepted,
                timestamp: new Date() })
        );
        closeCookiConfig()
    }

    const hasCookieConsentExpired = () => {
        const consent = JSON.parse(localStorage.getItem(COOKIE_CONSENT_KEY));
        if (!consent) return true;

        const now = new Date();
        const expiry = new Date(consent.timestamp);
        expiry.setDate(expiry.getDate() + CONSENT_EXPIRY_DAYS);

        return now > expiry;
    }

    useEffect(() => {
        if (hasCookieConsentExpired()) {
            setShowCookieConfig(true)
        }
    }, [])

    const renderCustomiseCookieModal = () => {
        return (
            <styled.Modal>
                <styled.ModalInnerContainer>
                    <styled.CustomCookieSection alignment={"column"}>
                        <div>
                            <h5>Essential Cookies</h5>
                            <p>These cookies are necessary for the website to function and cannot be switched off in our system. They may also use your IP address to determine your location for essential site operations.</p>
                        </div>
                        <styled.ModalButtonContainer>
                            <p style={{ width: "100%"}}>Always Active</p>
                        </styled.ModalButtonContainer>
                    </styled.CustomCookieSection>
                    <styled.dashedLine />
                    <styled.CustomCookieSection style={{ flexBasis: "40%" }} alignment={"column"}>
                        <div>
                            <h5>Performance Cookies</h5>
                            <p>These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our website.</p>
                        </div>
                        <styled.ModalButtonContainer>
                            <styled.PrimaryButton onClick={() => {
                                acceptCookie()
                                setShowCustomiseModal(false)
                                setShowCookieConfig(false)
                            }}>Accept</styled.PrimaryButton>
                            <styled.OutlineButton onClick={() => {
                                acceptCookie(false)
                                setShowCustomiseModal(false)
                                setShowCookieConfig(false)
                            }}>Reject</styled.OutlineButton>
                        </styled.ModalButtonContainer>
                    </styled.CustomCookieSection>
                </styled.ModalInnerContainer>
            </styled.Modal>
        )
    }

    const closeCustomiseCookieModal = () => {
        setShowCustomiseModal(false)
    }

    const closeCookiConfig = () => {
        setShowCookieConfig(false)
    }

    return (
        <div id="cookie-popup">
        {showCustomiseModal && renderCustomiseCookieModal()}
         {!showCustomiseModal && showCookieConfig && <styled.OuterContainer>
            <styled.CookieInfo>
                <h5>Our Website uses Cookies</h5>
                <p>PhactMI relies on cookies to improve your online experience. Cookies are used to analyze our website traffic and may include tracking your location.</p>
            </styled.CookieInfo>
            <styled.CookieButtonContainer>
                <styled.OutlineButton onClick={() => setShowCustomiseModal(true)}>Set Preferences</styled.OutlineButton>
                <styled.SecondaryButton onClick={() => acceptCookie(false)}>Use essential cookies only</styled.SecondaryButton>
                <styled.PrimaryButton onClick={() => acceptCookie(true)}>Accept all cookies</styled.PrimaryButton>
            </styled.CookieButtonContainer>
        </styled.OuterContainer>}
        {showCookieConfig && <styled.OverlayImage onClick={closeCustomiseCookieModal}>
            {/* <img src={OverlayImage}></img> */}
          </styled.OverlayImage>}
        </div>
    )
}

export default CookiePopup